<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title pt-2">
        <div class="row px-1">
          <!--Messaggio con rapportino + utente + stato-->
          <div class="col-12 d-flex align-items-center py-1 px-2">
            <h3 class="m-0" [ngClass.md]="'mr-1'">{{ "WORKDAY_REPORT_OF" | translate }} {{ monthSelectedReport }} {{ report.year }}</h3>
            <span [ngClass.sm]="'mt-1'" class="font-small-3 badge badge-secondary ml-1" *ngIf="statusReport === -1">{{ "STATUS.NOT_SAVED" | translate }}</span>
            <div [ngClass.xl]="'ml-1'">
              <span [ngClass.sm]="'mt-1'" class="font-small-3 badge badge-success" *ngIf="statusReport === 2">{{ "APPROVED" | translate }}</span>
              <span [ngClass.sm]="'mt-1'" class="font-small-3 badge badge-warning" *ngIf="statusReport === 1">{{ "PENDING" | translate }}</span>
              <span [ngClass.sm]="'mt-1'" class="font-small-3 badge badge-danger" *ngIf="statusReport === 3">{{ "REJECTED" | translate }}</span>
              <span [ngClass.sm]="'mt-1'" class="font-small-3 badge badge-info" *ngIf="statusReport === 0">{{ "STATUS.SAVED" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body" *ngIf="report">
        <!--header tabella-->
        <div class="row" id="table-header" *ngIf="!_utilService.isMobile && !_utilService.isTablet" #tableHeader>
          <div class="col-xl-2 col-12">
            <h4>{{ "DAYS" | translate | titlecase }}</h4>
          </div>
          <div class="col-xl-2 col-12">
            <h4>{{ "WORKED_HOURS" | translate }}</h4>
          </div>
          <div class="col-xl-3 col-12">
            <h4>{{ "EXTRA_HOURS" | translate }}</h4>
          </div>
          <div class="col-xl-3 col-12">
            <h4>{{ "TITLES.COMMISSIONS" | translate }}</h4>
          </div>
          <div class="col-xl-2 col-12">
            <h4>{{ "NOT_WORKED_HOURS" | translate }}</h4>
          </div>
        </div>
        <!--elenco giorni-->
        <div class="row align-items-center day-row py-2" *ngFor="let day of daysOfTheMonth" [ngClass]="getDayRowClasses(day)">
          <div class="col-12" (click)="openRow(day)">
            <div class="row align-items-center">
              <!--Giorno-->
              <div class="col-xl-2 col-12 cursor-pointer">
                <div class="d-flex align-items-center">
                  <div class="px-0 mr-05" *ngIf="openedRow !== day && report[day].extra > 0">
                    <i [data-feather]="'chevron-down'" class="text-secondary" size="20"></i>
                  </div>
                  <div class="px-0 mr-05" *ngIf="openedRow === day && report[day].extra > 0">
                    <i [data-feather]="'chevron-up'" class="text-secondary" size="20"></i>
                  </div>
                  <span>{{ _utilService.formatDate(day, "dddd DD") | titlecase }}</span>
                </div>
              </div>
              <!--Ore lavorative-->
              <div class="col-xl-2 col-12">
                <span class="badge" [ngClass]="report[day].working_hours < 1 ? 'badge-light-warning' : 'badge-warning'"> {{ report[day].working_hours }} {{ "WORKED_HOURS" | translate | lowercase }} </span>
              </div>
              <!--Ore extra-->
              <div class="col-xl-3 col-12 extra-hours">
                <div class="extra-hours__closed" *ngIf="openedRow !== day">
                  {{ _utilService.isMobile || _utilService.isTablet ? ("EXTRA" | translate) + ":" : null }}
                  <!-- ore extra sulle commesse -->
                  <span *ngFor="let comm of report[day].commissions; let i = index">
                    <span *ngIf="comm.extra.hours > 0">
                      <span class="badge badge-light-secondary" *ngIf="comm.extra.hours_km === 0 && comm.extra.hours_payroll === 0"
                            [ngbTooltip]="comm.extra.hours + ('_EXTRA_HOURS_ALLOCATED_TO_' | translate) + comm.client_name + ('_AS_' | translate) + (comm.extra.type_name | lowercase)">
                        {{ comm.extra.hours }}h {{ comm.extra.type_name }} ({{ comm.client_name }})
                      </span>
                      <span class="badge badge-light-secondary" *ngIf="comm.extra.hours_km > 0">{{ comm.extra.hours_km }}h {{ "REFUND_KILOMETER" | translate }}</span>
                      <span class="badge badge-light-secondary" *ngIf="comm.extra.hours_payroll > 0">{{ comm.extra.hours_payroll }}h {{ "REFUND_PAYROLL" | translate }}</span>
                    </span>
                  </span>
                  <!-- extra su costi di struttura -->
                  <span *ngFor="let structure of report[day].structures; let i = index">
                    <span *ngIf="structure.extra.hours > 0">
                      <span
                        class="badge badge-light-secondary"
                        placement="left"
                        *ngIf="structure.extra.hours_km === 0 && structure.extra.hours_payroll === 0"
                        [ngbTooltip]="structure.extra.hours + ('_EXTRA_HOURS_ALLOCATED_TO_' | translate) + structure.cost_description + ('_AS_' | translate) + (structure.extra.type_name | lowercase)"
                      >
                        {{ structure.extra.hours }}h {{ structure.extra.type_name }} ({{ structure.cost_description }})
                      </span>
                      <span class="badge badge-light-secondary" *ngIf="structure.extra.hours_km > 0" [ngbTooltip]="('STRUCTURE_COST' | translate) + ' ' + structure.company_name + ': ' + structure.cost_description"
                      >{{ structure.extra.hours_km }}h {{ "REFUND_KILOMETER" | translate }}</span
                      >
                      <span class="badge badge-light-secondary" *ngIf="structure.extra.hours_payroll > 0" [ngbTooltip]="('STRUCTURE_COST' | translate) + ' ' + structure.company_name + ': ' + structure.cost_description"
                      >{{ structure.extra.hours_payroll }}h {{ "REFUND_PAYROLL" | translate }}</span
                      >
                    </span>
                  </span>
                </div>
                <div *ngIf="openedRow === day">
                  <span *ngFor="let comm of report[day].commissions; let i = index">
                    <span class="mr-05 mb-05" *ngIf="comm.extra.hours > 0">
                      <span class="badge badge-light-secondary">{{ comm.extra.hours - comm.extra.hours_km - comm.extra.hours_payroll }} h {{ comm.extra.type_name }} ({{ comm.commission_description }})</span>
                    </span>
                  </span>
                  <span *ngFor="let structure of report[day].structures; let i = index">
                    <span class="mr-05 mb-05" *ngIf="structure.extra.hours > 0">
                      <span class="badge badge-light-secondary"
                      >{{ structure.extra.hours - structure.extra.hours_km - structure.extra.hours_payroll }} h {{ structure.extra.type_name }} ({{ structure.cost_description }})</span
                      >
                    </span>
                  </span>
                </div>
              </div>
              <!--Ore allocate sulle commesse-->
              <div class="col-xl-3 col-12">
                <div *ngIf="report[day].allocated_hours >= report[day].working_hours && report[day].allocated_hours > 0 && openedRow !== day; else addCommissionHoursBtn">
                  <!-- badge ore lavorate su commesse -->
                  <span
                    *ngFor="let comm of report[day].commissions; let i = index"
                    class="badge {{ commissionColors['order' + comm.order_id]?.color }} mr-05"
                    [ngClass]="{'d-none': comm.worked < 1, 'mb-05': report[day].commissions.length > 1}"
                    [ngbTooltip]="comm.worked + ('_HOURS_ALLOCATED_TO_' | translate) + comm.commission_description"
                  >
                    {{ comm.worked }}h {{ comm?.client_name }}
                  </span>
                  <!-- badge ore lavorate su costi di struttura -->
                  <span
                    *ngFor="let structure of report[day].structures; let i = index"
                    class="badge badge-light-primary mr-05"
                    [ngClass]="{'d-none': structure.worked < 1, 'mb-05': report[day].structures.length > 1}"
                    [ngbTooltip]="structure.worked + ('_HOURS_ALLOCATED_TO_' | translate) + structure.cost_description"
                  >
                    {{ structure.worked }}h {{ structure?.company_name }}
                  </span>
                </div>
                <ng-template #addCommissionHoursBtn>
                  <button *ngIf="openedRow === day" class="btn btn-outline-secondary rounded-circle p-05 mx-auto">
                    <i data-[data-feather]="'minus'" size="15"></i>
                  </button>
                </ng-template>
              </div>
              <div class="col-xl-2 col-12">
                <div class="d-flex" *ngFor="let permission_hour of report[day].absences">
                  <div [ngbTooltip]="permission_hour?.name.length > 15 ? permission_hour.name : null" class="badge badge-light-primary mr-05 text-break-line-1">
                    {{ permission_hour.category === "permesso" ? permission_hour.hours + "h" : "" }} {{ permission_hour.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--dettaglio giorno-->
          <div class="col-12 day-details" [ngClass]="openedRow === day ? 'opened' : ''" *ngIf="statusReport < 2">
            <div class="row align-items-center">
              <div class="col-2 font-weight-bold">{{ "MENU.COMMISSION" | translate }}</div>
              <div class="col-3 font-weight-bold">{{ "EXTRA_HOURS" | translate }}</div>
              <div class="col-3 font-weight-bold">{{ "REFUND_KILOMETER" | translate }}</div>
              <div class="col-3 font-weight-bold">{{ "REFUND_PAYROLL" | translate }}</div>
            </div>
            <!-- ore extra sulle commesse -->
            <div *ngFor="let comm of report[day].commissions; let i = index">
              <div class="row day-detail align-items-center" *ngIf="comm.extra.hours > 0">
                <!--nome commessa con tooltip descrizione-->
                <div class="col-2" [ngbTooltip]="comm.commission_description" placement="top-left">{{ comm.commission_description }}</div>
                <!--input ore extra dichiarate-->
                <div class="col-3 worked-hours">
                  <input type="number" class="form-control" [value]="comm.extra.hours" [disabled]="true" [readOnly]="true" />
                </div>
                <div class="col-3 worked-hours">
                  <!--input ore extra -->
                  <input
                    class="form-control"
                    type="number"
                    min="0"
                    [ngbTooltip]="'REFUND_KILOMETER' | translate"
                    [(ngModel)]="comm.extra.hours_km"
                    [max]="comm.extra.hours"
                    (change)="toInt($event); setExtra(day, i, 'km')"
                  />
                </div>
                <div class="col-3 worked-hours">
                  <input
                    class="form-control"
                    type="number"
                    min="0"
                    [ngbTooltip]="'REFUND_PAYROLL' | translate"
                    [(ngModel)]="comm.extra.hours_payroll"
                    [max]="comm.extra.hours"
                    (change)="toInt($event); setExtra(day, i, 'payroll')"
                  />
                </div>
              </div>
            </div>
            <!-- ore extra sui costi di struttura -->
            <div *ngFor="let structure of report[day].structures; let i = index">
              <div class="row day-detail align-items-center" *ngIf="structure.extra.hours > 0">
                <!--nome commessa con tooltip descrizione-->
                <div class="col-2" [ngbTooltip]="('STRUCTURE_COST' | translate) + ' ' + structure.company_name + ': ' + structure.cost_description" placement="top-left">{{ structure.cost_description }}</div>
                <!--input ore extra dichiarate-->
                <div class="col-3 worked-hours">
                  <input type="number" class="form-control" [value]="structure.extra.hours" [disabled]="true" [readOnly]="true" />
                </div>
                <div class="col-3 worked-hours">
                  <!--input ore extra -->
                  <input
                    class="form-control"
                    type="number"
                    min="0"
                    [ngbTooltip]="'REFUND_KILOMETER' | translate"
                    [(ngModel)]="structure.extra.hours_km"
                    [max]="structure.extra.hours"
                    (change)="toInt($event); setExtra(day, i, 'km', 'structures')"
                  />
                </div>
                <div class="col-3 worked-hours">
                  <input
                    class="form-control"
                    type="number"
                    min="0"
                    [ngbTooltip]="'REFUND_PAYROLL' | translate"
                    [(ngModel)]="structure.extra.hours_payroll"
                    [max]="structure.extra.hours"
                    (change)="toInt($event); setExtra(day, i, 'payroll', 'structures')"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 day-details" [ngClass]="openedRow === day ? 'opened' : ''" *ngIf="statusReport === 2">
            <div class="row align-items-center">
              <div class="col-2 font-weight-bold">{{ "MENU.COMMISSION" | translate }}</div>
              <div class="col-2 font-weight-bold">{{ "EXTRA_HOURS" | translate }}</div>
              <div class="col-3 font-weight-bold">{{ "REFUND_KILOMETER" | translate }}</div>
              <div class="col-3 font-weight-bold">{{ "REFUND_PAYROLL" | translate }}</div>
            </div>
            <div *ngFor="let comm of report[day].commissions; let i = index">
              <div class="row day-detail align-items-center" *ngIf="comm.extra.hours > 0">
                <!--nome commessa con tooltip descrizione-->
                <div class="col-2" [ngbTooltip]="comm.commission_description" placement="top-left">{{ comm.commission_description }}</div>
                <!--input ore extra dichiarate-->
                <div class="col-2">{{ comm.extra.hours }}h</div>
                <div class="col-3">{{ comm.extra.hours_km }}h</div>
                <div class="col-3">{{ comm.extra.hours_payroll }}h</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer border-0 pt-0">
        <div class="row">
          <div class="offset-xl-2 col-xl-2 col-12">
            <label>{{ "WORKED_HOURS" | translate }}:</label>
            <div class="badge badge-warning d-block w-25">{{ totalWorkedHours }}h</div>
          </div>
          <div class="col-xl-4 offset-xl-3 col-12" *ngIf="commissionTotalHours && (commissionTotalHours | json) != ({} | json)">
            <label>{{ "HOURS_ALLOCATED_COMMISSIONS" | translate }}:</label>
            <div>
              <span *ngFor="let comm of Object.keys(commissionTotalHours); let i = index" class="badge {{ commissionColors[comm].color }} mr-05 mb-05">{{ commissionTotalHours[comm].hours }} h {{ commissionTotalHours[comm].name }}</span>
            </div>
          </div>
        </div>
        <div class="row my-1">
          <!--Conteggio ore totali -->
          <div class="col-xl-2 col-12" [ngClass.sm]="'my-05'">
            <label>{{ "NOT_WORKED_HOURS" | translate }}:</label>
            <div>{{ totalNotWorkedHours }}h</div>
          </div>
          <div class="col-xl-2 col-12">
            <label>{{ "EXTRA_HOURS" | translate }}:</label>
            <div class="mr-3">{{ totalExtraHours }}h</div>
          </div>
          <div class="col-xl-2 col-12">
            <label>{{ "REFUND_KM" | translate }}:</label>
            <div class="mr-3">{{ totalExtraHours_km }}h</div>
          </div>
          <div class="col-xl-3 col-12">
            <label>{{ "REFUND_PAYROLL" | translate }}:</label>
            <div class="mr-3">{{ totalExtraHours_payroll }}h</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-right" has_capability="edit_workday_report_status" *ngIf="statusReport < 2">
            <!--Tasto rifiuta -->
            <button class="btn btn-outline-secondary mr-075 mt-1" (click)="showRejectModal(noteRejectModal)">{{ "REJECT" | translate }}</button>
            <!-- Bottoni salva aggiorna e invia report -->
            <button class="btn btn-primary mt-1" (click)="update()" [disabled]="totalExtraHours > totalExtraHours_km + totalExtraHours_payroll">{{ "APPROVE" | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- note Rejected Absence Modal -->
<ng-template #noteRejectModal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "INSERT_MOTIVATION_NOTE" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="rejectedNote">{{ "MOTIVATION" | translate }}<sup class="text-danger">*</sup></label>
        <textarea [(ngModel)]="rejectedNote" class="form-control" name="rejectedNote" id="rejectedNote" cols="45" rows="3"></textarea>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button [disabled]="rejectedNote.length < 5" (click)="reject()" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / note Rejected Absence Modal -->
